 

//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

namespace Dataport.OD.ErAnMiZuWohngeld.OdHelp {
    export class OdHelpBase {
        Init() {
        }

        readonly HelpHTMLSelector = "#HelpHTML";

    }
   
    $(() => {
        const page = new OdHelpBase();
        page.Init();
    });
}



